import { WebCheckInStates } from "../../@types/states/WebCheckIn.d";

const initialStates: WebCheckInStates = {
  isAvailable: false,
  bookingDetails: {},
};
export { initialStates, initialStates as default };
